import PropTypes from 'prop-types';
import { FormattedMessage } from 'dibs-react-intl';

import { ContemporaryLandingStyleRowItem } from './ContemporaryLandingStyleRowItem';

const shopNowCta = (
    <FormattedMessage id="contemporaryLanding.styleRow.shopNow" defaultMessage="Shop Now" />
);

export const ContemporaryLandingStyleRow = ({ items, rowIndex, showCta }) => {
    if (!items || !items.length) {
        return null;
    }

    return (
        <div className="rowFlex">
            {items.map((item, index) => {
                if (showCta) {
                    item = { ...item, cta: shopNowCta };
                }
                return (
                    <ContemporaryLandingStyleRowItem
                        key={`${item.title}-${index}`}
                        item={item}
                        rowIndex={rowIndex}
                    />
                );
            })}
        </div>
    );
};

ContemporaryLandingStyleRow.propTypes = {
    items: PropTypes.array,
    rowIndex: PropTypes.number.isRequired,
    showCta: PropTypes.bool.isRequired,
};
